import { CircledCheckFilledIcon, CircledXIcon } from '@primerai/icons';
import { useTheme } from 'styled-components';
import { get } from '~/utils/object';

const CHECKMARK_SIZE = 24;

const CheckmarkIcon = ({ checked = false }: { checked: boolean }) => {
  const theme = useTheme();
  const color = checked
    ? get<string>(theme, 'colors.$alerts.success', '#00AA00')
    : get<string>(theme, 'colors.$text.muted', '#666666');
  const Icon = checked ? CircledCheckFilledIcon : CircledXIcon;
  return <Icon color={color} height={CHECKMARK_SIZE} width={CHECKMARK_SIZE} />;
};

export default CheckmarkIcon;
